// extracted by mini-css-extract-plugin
module.exports = {"QuickReply":"QuickReply_QuickReply__2gN8H","VerticalButtons":"QuickReply_VerticalButtons__3GlHc"};